import { render, staticRenderFns } from "./CultivationMixtureComponents.vue?vue&type=template&id=2bdb98f8&scoped=true&"
import script from "./CultivationMixtureComponents.vue?vue&type=script&lang=js&"
export * from "./CultivationMixtureComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb98f8",
  null
  
)

export default component.exports